export const TEST_REQUEST = "TEST_REQUEST";
export const TEST_RECEIVE = "TEST_RECEIVE";
export const TEST_FAILURE = "TEST_FAILURE";
export const RESET_TEST = "RESET_TEST";
